module.exports = __webpack_public_path__ + "img/wx.1afee1e7.jpg";